import "./agreement.scss";
import dayjs, { Dayjs } from "dayjs";

import {
  autoinject,
  bindable,
  bindingMode,
  observable,
} from "aurelia-framework";
import { OidcService } from "../../services/oidc-service";
import { Router } from "aurelia-router";
import { LoginStage } from "../../enums/login-stage";
import { ChallengeService } from "../../services/challenge-service";
import Infrastructure, {
  ReleaseEnvironments,
} from "../../infrastructure/infrastructure";
@autoinject
export class Agreement {
  @bindable({ defaultBindingMode: bindingMode.toView })
  public returnUrl: string;
  @bindable({ defaultBindingMode: bindingMode.toView })
  public isLoading: boolean;
  @bindable({ defaultBindingMode: bindingMode.fromView })
  public stage: LoginStage;
  @bindable({ defaultBindingMode: bindingMode.twoWay })
  public passwordCheckResponse: any;
  @bindable({ defaultBindingMode: bindingMode.toView })
  public email: string;
  @bindable({ defaultBindingMode: bindingMode.twoWay })
  public showSuccessMessage: boolean;
  @bindable({ defaultBindingMode: bindingMode.twoWay })
  successFulTwoFAMessage: boolean = false;
  @bindable({ defaultBindingMode: bindingMode.twoWay })
  public isTwoFAActive: boolean;
  private readonly _router: Router;
  private readonly _oidcService: OidcService;
  private _challengeService: ChallengeService;
  public releaseEnvironment = Infrastructure.releaseEnvironment;
  public showUpdatePasswordWarning: boolean = false;
  public showUpdateTwoFAWarning: boolean = false;
  public isEmailUnderToggle: boolean = false;
  public isRequire2FA: boolean = false;
  public isRedirecting:boolean=false;

  public today: Dayjs = dayjs().startOf("day");
  public daysLeft: number = 0;
  public daysLeftTwoFA: number = 0;
  public cutOffDate: string;
  public graceDate: string;
  public graceDateTwoFA: string;
  
  public constructor(
    oidcService: OidcService,
    router: Router,
    challengeService: ChallengeService
  ) {
    this._oidcService = oidcService;
    this._challengeService = challengeService;
    this._router = router;
    let str = "No key pressed";
    let str1 = "";
    document.body.addEventListener("keydown", (event) => {
      const btnCancel = document.getElementById("btn_cancel");
      const btnOk = document.getElementById("btn_ok");
      const key = event.key;
      switch (key) {
        case "ArrowLeft":
          str = "Left";
          btnCancel.classList.add("agreement-cancel-add");
          btnOk.classList.remove("agreement-ok-add");
          btnOk.classList.add("agreement-ok");
          break;
        case "ArrowRight":
          str = "Right";
          btnCancel.classList.remove("agreement-cancel-add");
          btnCancel.classList.add("agreement-cancel");
          btnOk.classList.add("agreement-ok-add");
          break;
      }
      if (key === "Enter") {
        if (str == "Left") {
          btnCancel.click();
        } else if (str == "Right") {
          btnOk.click();
        }
      }
    });
  }

  public attached() {
    if (this.passwordCheckResponse.endOfGracePeriod != null) {
      this.checkPasswordDate();
    }
    this.isEmailUnderToggle = window.sessionStorage.getItem('isEmailUnderToggle') === 'true'
    if (this.isEmailUnderToggle && !this.isTwoFAActive) {
       this.checkCutOffDate();
    }
  }

  public checkPasswordDate() {
    this.showUpdatePasswordWarning = true;

    this.graceDate = dayjs(this.passwordCheckResponse.endOfGracePeriod).format(
      "MMMM D, YYYY"
    );

    let lastDate = dayjs(
      this.passwordCheckResponse.endOfGracePeriod,
      "YYYY-MM-DD"
    );
    this.daysLeft = lastDate.diff(this.today, "d");
  }

  public async checkCutOffDate() {
    const response = await this._challengeService.getCutOffDate();
    this.cutOffDate = response?.cutoffDate || '';
    if (this.cutOffDate) {
      this.showUpdateTwoFAWarning = true;
      this.graceDateTwoFA = dayjs(this.cutOffDate).format("MMMM D, YYYY");

      let lastDate = dayjs(this.graceDateTwoFA, "YYYY-MM-DD");
      this.daysLeftTwoFA = lastDate.diff(this.today, "d") + 1;
      this.daysLeftTwoFA = this.daysLeftTwoFA < 0 ? 0 : this.daysLeftTwoFA ;
      this.isRequire2FA = this.daysLeftTwoFA ? false :true;
    }
  }
  public async cancelLogin() {
    await this._oidcService.logout();
  }

  public continueLogin() {
    this.isRedirecting=true;
    window.location.replace(this.returnUrl);
  }

  public goToTwoFA() {
    window.sessionStorage.removeItem("returnUrlToApplication");
    if (this.returnUrl && !this.isRequire2FA) {
      window.sessionStorage.setItem("returnUrlToApplication", this.returnUrl);
    }

    switch (this.releaseEnvironment) {
      case ReleaseEnvironments.production:
        this._router.navigate(`https://identity.axxessweb.com/profile/security/second-factor?email=${this.email}`);
        break;
      case ReleaseEnvironments.feature1:
        this._router.navigate(`https://identity.test.axxess.tech/profile/security/second-factor?email=${this.email}`);
        break;
      case ReleaseEnvironments.local:
        this._router.navigate(`https://localhost:5001/profile/security/second-factor?email=${this.email}`);
        break;
      case ReleaseEnvironments.testing:
        this._router.navigate(`https://identity.test.axxess.tech/profile/security/second-factor?email=${this.email}`);
        break;
      default:
        return;
    }
  }

  public redirectToUpdatePassword() {
    this.stage = LoginStage.updatePassword;
  }
}
